<template>
  <div v-if="questions.length > 0">
    <ul
      v-for="question in questions"
      :key="question.id"
      class="relative"
    >
      <li class="my-3.5 min-w-full cursor-pointer">
        <ContactQuestion :question="question" />
      </li>
    </ul>
  </div>
</template>


<script lang="ts" setup>
import {useQuestionsQuery} from '~/graphql/graphql';

const {result} = useQuestionsQuery();
const questions = computed(() => result.value?.questions ?? []);
</script>
